import axios from '../../../api/axios.js'
import axios2 from '../../../api/axios2.js'
import { b2bUrls } from '../../../api/config.js'
// 订单列表
export const getMyOrderList = params => {
    return axios.get('order/api/app/orders', { params })
}
// 订单详情
export const findOrderDetails = params => {
    return axios.get(`order/api/app/orders/${params.id}`, { params })
}
// 确认收货
export const getTakeOrder = params => {
    return axios.put(`order/api/app/orders/${params.deliveryOrderId}/confirm-receipt-goods`, params)
}
// 关闭订单
export const orderClose = params => {
    return axios.put(`order/api/child-orders/${params.orderId}/close`, params)
}
// 订单退款
export const orderTk = params => {
    return axios.post(`order/api/refund-orders`, params)
}
// 撤销退款
export const revokeOrder = params => {
    return axios.put(`order/api/refund-orders/${params.refundOrderId}/revoke`, params)
}
// 订单物流
export const logisticInfo = params => {
    return axios.get(`order/api/app/orders/express/${params.deliveryOrderId}`)
}
// 预售订单列表
export const presellOrderList = params => {
    return axios.get(`order/api/presale/orders`, { params })
}
// 预售商品滚动条
export const presellSlider = params => {
    return axios.get(`order/openapi/orders/presale-scroll-bar`, { params })
}
// 待开票列表
export const deliveryList = params => {
    return axios.get(`order/api/invoice/app/delivery-list`, { params })
}
// 获取开票金额
export const invoiceAmount = params => {
    return axios.post(`order/api/invoice/app/total-invoice-amount`, params)
}
// 发票列表
export const invoiceList = params => {
    return axios.get(`order/api/invoice/app/invoice-list`, { params })
}
// 上次申请的发票信息
export const invoiceHostory = params => {
    return axios.post(`order/api/invoice/app/last`, params)
}
// 申请开票
export const applyInvoice = params => {
    return axios.post(`order/api/invoice/app`, params)
}
// 发票详情
export const invoiceDetailData = params => {
    return axios.get(`order/api/invoice/app/${params.id}`, { params })
}
// 确认订单
export const getSubmitOrder = params => {
    return axios.post(`order/api/orders/confirm`, params)
}
// 提交订单
export const setSubmitOrder = params => axios2(b2bUrls + '/order/api/orders/submit', params, 'post')
// 收银台获取支付信息
export const payInfo = params => {
    return axios.get(`order/api/child-orders/cashier`, { params })
}
// 运费接口
export const getFreight = params => {
    return axios.post(`order/api/app/freight/confirm`, params)
}

// 获取运费明细列表
export const getFreightDetail = params => {
    return axios.get(`order/api/freight-orders/${params.id}/order-detail`, { params })
}

// 选择退款商品列表
export const getRefundGoodsList = params => {
    return axios.get(`order/api/child-orders/${params.childOrderId}/refund-products`, { params })
}

// 售后列表
export const getRenturens = params => {
    return axios.get('order/api/returns', { params })
}

// 获取售后原因
export const getReason = params => {
    return axios.get('order/open/return-reasons', { params })
}

// 售后申请
export const getAfter = params => {
    return axios.post('order/api/returns', params)
}

// 售后详情
export const getReturnsDetail = params => {
    if (params.orderType === 1) {
        return axios.get(`order/api/returns/${params.id}`)
    } else {
        return axios.get(`order/api/refund-orders/${params.id}`)
    }
}

// 售后申请撤销
export const getReturnsRevoke = params => {
    if (params.orderType === 1) {
        return axios.patch(`order/api/returns/${params.id}/revoke`)
    } else {
        return axios.patch(`order/api/refund-orders/${params.id}/revoke`)
    }
}
